import { render, staticRenderFns } from "./debtsPage.vue?vue&type=template&id=948295f2&scoped=true&"
import script from "./debtsPage.vue?vue&type=script&lang=ts&"
export * from "./debtsPage.vue?vue&type=script&lang=ts&"
import style0 from "./debtsPage.vue?vue&type=style&index=0&id=948295f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "948295f2",
  null
  
)

export default component.exports